// extracted by mini-css-extract-plugin
export default {"subcategoryList":"_2egTL","subcategoryIcon":"_2mijV","link":"_2w3Jy","labelWrapper":"ni6hx","label":"fLC06","newPostIndicator":"_2s2dq"};